import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { IEvaluators } from "app/models/core/home/evaluators";
import { IPtTests } from "app/models/core/home/ptTests";
import { IAddProficiency } from "app/models/core/lab/proficiency";
import { LabService } from "app/services/lab/lab.service";



@Component({
  selector: 'addLabProficiency',
  templateUrl: './addLabProficiency.component.html',
})

export class AddLabProficiencyComponent implements OnInit {

  public proficiencies: IPtTests[];
  public eval: IEvaluators[];

  public newProficiency = new UntypedFormGroup({
    Analyte: new UntypedFormControl('', [Validators.required]),
    Specialty: new UntypedFormControl('', [Validators.required]),
    SubSpecialty: new UntypedFormControl('', [Validators.required]),
    TestCode: new UntypedFormControl('', [Validators.required]),
    Evaluator: new UntypedFormControl('', [Validators.required]),
    TestId: new UntypedFormControl('', [Validators.required]),
  });

  constructor(
    private labService: LabService,
    private dialogRef: MatDialogRef<AddLabProficiencyComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  ngOnInit(): void {
    this.getEvaluators();
    this.getTests();
  }

  getEvaluators() {
    this.labService.getEvaluators().subscribe(
      res => {
        this.eval = res;
      },
      error => console.log('error: ', error),
      () => {
      }
    );
  }

  getTests() {
    this.labService.getProficiencyTests().subscribe(
      res => {
        this.proficiencies = res;
      },
      error => console.log('error: ', error),
      () => {
      }
    );
  }

  updateFields(value) {
    let item: IPtTests;
    this.proficiencies.forEach(function (val: IPtTests) {
      if (val.ptTest == value) {
        item = val;
      }
    });
    this.newProficiency.patchValue({
      Specialty: item.specialty,
      SubSpecialty: item.subSpecialty,
      TestCode: item.tCode,
      TestId: item.tId
    })

  }

  save(): void {
    if (this.newProficiency.valid) {
      let form = this.newProficiency.value;
      let saveProficiency: IAddProficiency = {
        labId: +this.labService.lab.labId,
        analyte: form.Analyte,
        specialty: form.Specialty,
        subSpecialty: form.SubSpecialty,
        testCode: form.TestCode,
        evaluator: form.Evaluator,
        testId: form.TestId,
        year: form.Year,
        period: form.Period,
        percent: form.Percent,
        comments: form.Comments,
        dateCreated: null,
        createdBy: null,
        lastUpdated: null,
        updatedBy: null
      }

      this.labService.addLabProficiency(saveProficiency).subscribe(
        () => {
          this.dialogRef.close(saveProficiency);
        },
        error => {
          console.log('error: ', error);
          alert(error);
        },
        () => {
        }
      );
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}